import dataService from 'utils/dataservice';

export function getTreeRootData() {
    return dataService.getRequest('getTreeRootData');
}

export function getTreeNodeData(id, customProps) {
    if (id == -1) {
        id = undefined;
    }
    return dataService.getRequest('getTreeNodeData', 
            { node: id, allowedTypes: customProps.allowedTypes, allowedExtensions: customProps.allowedExtensions })
}

export function addNewFolderRequest(data) {
    return dataService.postRequest('addNewFolder', data);
}

export function deleteNodeById(id) {
    return dataService.deleteRequest('deleteNode', { id });
}

export function exportMediaById(id) {
    return dataService.getRequest('exportMedia', { parentId: id });
}

export function downLoadById(id) {
    return dataService.getRequest('downLoadMedia', { id });
}

export function importMediaHistory() {
    return dataService.getRequest('importMediaHistory');
}

export function getDownLoadByIDUrl(id) {
    return dataService.getCompleteGetURL('downLoadMedia', { id });
}

export function searchMedia(query, folderId, page, limit) {
    const queryParam = {
        filter: [
            {
                operator: "like",
                value: query,
                property: "fullpath",
                type: "string"
            }
        ],
        limit: limit,
        page: page,
        folderId: folderId === -1 ? 1 : folderId
    };
    return dataService.postRequest('mediaSearch', queryParam);
}